module.exports = __webpack_public_path__ + "img/logo.8b192b61.svg";